// JRD Fuel & Auto - Constants & Configuration

// ============================================================================
// BRANDING
// ============================================================================

export const JRD_COLORS = {
  // Primary palette from JRD Companies logo
  orange: '#E85D3B',
  green: '#2D5A3D',

  // Extended palette
  orangeLight: '#FF7A54',
  orangeDark: '#C44A2B',
  greenLight: '#3D7A4D',
  greenDark: '#1D3A2D',

  // Accent colors
  yellow: '#F4A826',
  gold: '#C9A959',
  amber: '#D4A574',

  // Background colors
  bgDark: '#0A0A0F',
  bgDarker: '#050508',
  bgCard: '#12121A',
  bgCardHover: '#1A1A24',
  bgInput: '#0F0F14',

  // Text colors
  textPrimary: '#E8E8E8',
  textSecondary: '#A0A0A0',
  textMuted: '#666666',

  // Status colors
  success: '#22C55E',
  warning: '#F59E0B',
  error: '#EF4444',
  info: '#3B82F6',
} as const;

export const JRD_ASCII_LOGO = `
░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░
     ██╗██████╗ ██████╗     ███████╗██╗   ██╗███████╗██╗          ██╗       █████╗ ██╗   ██╗████████╗ ██████╗
     ██║██╔══██╗██╔══██╗    ██╔════╝██║   ██║██╔════╝██║         ██╔╝      ██╔══██╗██║   ██║╚══██╔══╝██╔═══██╗
     ██║██████╔╝██║  ██║    █████╗  ██║   ██║█████╗  ██║        ██╔╝       ███████║██║   ██║   ██║   ██║   ██║
██   ██║██╔══██╗██║  ██║    ██╔══╝  ██║   ██║██╔══╝  ██║       ██╔╝        ██╔══██║██║   ██║   ██║   ██║   ██║
╚█████╔╝██║  ██║██████╔╝    ██║     ╚██████╔╝███████╗███████╗ ██╔╝  ██╗    ██║  ██║╚██████╔╝   ██║   ╚██████╔╝
 ╚════╝ ╚═╝  ╚═╝╚═════╝     ╚═╝      ╚═════╝ ╚══════╝╚══════╝ ╚═╝   ╚═╝    ╚═╝  ╚═╝ ╚═════╝    ╚═╝    ╚═════╝
░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░
`;

export const JRD_ASCII_COMPACT = `
██╗██████╗ ██████╗
██║██╔══██╗██╔══██╗
██║██████╔╝██║  ██║
██║██╔══██╗██║  ██║
██║██║  ██║██████╔╝
╚═╝╚═╝  ╚═╝╚═════╝
`;

export const FUEL_AUTO_ASCII = `
███████╗██╗   ██╗███████╗██╗       ██╗        █████╗ ██╗   ██╗████████╗ ██████╗
██╔════╝██║   ██║██╔════╝██║      ██╔╝       ██╔══██╗██║   ██║╚══██╔══╝██╔═══██╗
█████╗  ██║   ██║█████╗  ██║     ██╔╝        ███████║██║   ██║   ██║   ██║   ██║
██╔══╝  ██║   ██║██╔══╝  ██║    ██╔╝         ██╔══██║██║   ██║   ██║   ██║   ██║
██║     ╚██████╔╝███████╗██║   ██╔╝   ██╗    ██║  ██║╚██████╔╝   ██║   ╚██████╔╝
╚═╝      ╚═════╝ ╚══════╝╚═╝   ╚═╝    ╚═╝    ╚═╝  ╚═╝ ╚═════╝    ╚═╝    ╚═════╝
`;

// ============================================================================
// BUSINESS ENTITIES
// ============================================================================

export const JRD_ENTITIES = {
  holiday: {
    name: 'Holiday Stationstores #3851',
    site: '2653851',
    account: '524025',
    address: '16355 Ipava Ave, Lakeville, MN',
    lat: 44.6497,
    lng: -93.2427,
    gasbuddyId: '67587',
    wholesaleSupplier: 'Circle K',
    email: 'holiday3851@jrdcompanies.com',
  },
  innout: {
    name: 'IN N OUT Market',
    address: '1935 English St, Maplewood, MN 55119',
    phone: '651-770-9889',
    gasbuddyId: '186831',
    wholesaleSupplier: 'Waterford/World Fuel',
    email: 'jdurand@jrdcompanies.com',
  },
  maplewooodAuto: {
    name: 'Maplewood Auto Service',
    address: '1929 English St, Maplewood, MN',
    laborRate: 125,
    partsMarkup: 60,
  },
} as const;

// ============================================================================
// QBO CONFIGURATION
// ============================================================================

export const QBO_CONFIG = {
  dyHoldings: {
    realmId: '9341454651353319',
    name: 'DY Holdings LLC',
    mode: 'readonly' as const,
  },
  jrdHoldings: {
    realmId: '9341455939660767',
    name: 'JRD Holdings LLC',
    mode: 'readwrite' as const,
  },
  jrdCompanies: {
    realmId: '9341455682723877',
    name: 'JRD Companies Maplewood LLC',
    mode: 'readwrite' as const,
  },
  jrdAuto: {
    realmId: '9341455682738003',
    name: 'JRD Auto Maplewood LLC',
    mode: 'readwrite' as const,
  },
} as const;

export const QBO_ACCOUNTS = {
  eftClearing: { id: '1150040010', name: 'EFT Holiday Clearing' },
  apClearing: { id: '1150040012', name: 'Holiday AP Clearing' },
  salesDeposits: { id: '1150040000', name: 'Holiday Sales & Deposits' },
  dueFromCircleK: { id: '1150040001', name: 'Due from Circle K' },
  traditionCapital: { id: '68', name: 'Tradition Capital Bank' },
} as const;

export const QBO_VENDORS = {
  circleKFranchise: { id: '1', name: 'Circle K Franchise (CC Fees)' },
  circleKRelated: { id: '73270', name: 'Circle K Related' },
  circleKFuel: { id: '81840', name: 'Circle K Fuel/Wholesale' },
  mnLottery: { id: 'MNLOT', name: 'Minnesota Lottery' },
} as const;

// ============================================================================
// CLOUDFLARE CONFIGURATION
// ============================================================================

export const CLOUDFLARE_CONFIG = {
  accountId: '0ed06768c5340d75afc96a3457d141ab',
  zoneId: '62ca26bea967ff1fd59e887b09b37c23',
  d1DatabaseId: '433ddc43-1f14-40c2-894e-79c7efbca26c',
  workers: {
    jack2: 'jack2.workers.dev',
    jack2Api: 'jack2-api.workers.dev',
    qboBrain: 'qbo-brain.workers.dev',
    priceOTron: 'price-otron-api.workers.dev',
  },
  tunnels: ['main-hub', 'holiday', 'tanks', 'home', 'innout', 'maplewood'],
} as const;

// ============================================================================
// SUBSCRIPTION PLANS
// ============================================================================

export const SUBSCRIPTION_PLANS = {
  trial: {
    tier: 'trial' as const,
    name: 'Free Trial',
    price: 0,
    locations: 1,
    users: 1,
    durationDays: 14,
    features: ['1 location', '1 user', 'Basic features'],
  },
  starter: {
    tier: 'starter' as const,
    name: 'Starter',
    price: 29,
    locations: 1,
    users: 1,
    features: ['1 location', '1 user', 'Gas OR Auto module', 'Email support'],
    stripePriceId: 'price_starter_monthly',
  },
  professional: {
    tier: 'professional' as const,
    name: 'Professional',
    price: 49,
    locations: 3,
    users: 3,
    features: ['3 locations', '3 users', 'Both modules', 'Jack2 AI', 'Priority support'],
    stripePriceId: 'price_professional_monthly',
  },
  enterprise: {
    tier: 'enterprise' as const,
    name: 'Enterprise',
    price: 99,
    locations: 999,
    users: 10,
    features: ['Unlimited locations', '10 users', 'API access', 'Dedicated support', 'Custom integrations'],
    stripePriceId: 'price_enterprise_monthly',
  },
} as const;

export const ADDON_PRICING = {
  additionalUser: 12,
  additionalLocation: 15,
} as const;

// ============================================================================
// COMMODITIES
// ============================================================================

export const COMMODITIES = [
  { symbol: 'CL=F', name: 'WTI Crude', displayName: 'WTI' },
  { symbol: 'BZ=F', name: 'Brent Crude', displayName: 'BRENT' },
  { symbol: 'RB=F', name: 'RBOB Gasoline', displayName: 'RBOB' },
  { symbol: 'HO=F', name: 'Heating Oil', displayName: 'HO' },
  { symbol: 'NG=F', name: 'Natural Gas', displayName: 'NG' },
] as const;

// ============================================================================
// DATA REFRESH INTERVALS (milliseconds)
// ============================================================================

export const REFRESH_INTERVALS = {
  gasbuddyPrices: 5 * 60 * 1000, // 5 minutes
  competitorPrices: 15 * 60 * 1000, // 15 minutes
  commodities: 60 * 1000, // 1 minute
  tankLevels: 5 * 60 * 1000, // 5 minutes
  mitchell1Rates: 60 * 60 * 1000, // 1 hour
  wholesalePrices: 24 * 60 * 60 * 1000, // 1 day (email trigger)
} as const;

// ============================================================================
// FILE PROCESSING
// ============================================================================

export const HOLIDAY_FILE_CONFIG = {
  contraAccountPatterns: [
    /.*R$/, // Any account ending in R
    /50202-\d{3}-\d{3}R/, // Specific retail contra pattern
  ],
  validVendorIds: ['1', '73270', '81840', 'MNLOT'],
  removeZeros: true,
  removeNegativesForAP: true,
} as const;

// ============================================================================
// BOOT SEQUENCE
// ============================================================================

export const BOOT_SEQUENCE = {
  phase1Duration: 3000, // IBM logo
  phase2Duration: 3000, // "Nah... Jack made this"
  phase3Duration: 6000, // Gas pump + ASCII logo
  totalDuration: 12000,
} as const;

// ============================================================================
// API ENDPOINTS
// ============================================================================

export const API_ENDPOINTS = {
  health: '/api/health',
  // GasBuddy
  gasBuddyStation: '/api/gasbuddy/station',
  gasBuddyNearby: '/api/gasbuddy/nearby',
  gasBuddyLookup: '/api/gasbuddy/lookup',
  // Commodities
  commodities: '/api/commodities',
  // Wholesale
  wholesaleHoliday: '/api/wholesale/holiday',
  wholesaleInnout: '/api/wholesale/innout',
  wholesaleAll: '/api/wholesale/all',
  // Tanks
  tanks: '/api/tanks',
  // Mitchell1
  mitchell1Labor: '/api/mitchell1/labor',
  mitchell1WorkOrders: '/api/mitchell1/work-orders',
  mitchell1Customers: '/api/mitchell1/customers',
  mitchell1Inventory: '/api/mitchell1/inventory',
  // Margins
  marginHoliday: '/api/margin/holiday',
  marginInnout: '/api/margin/innout',
  // Jack2 AI
  jack2Chat: '/api/jack2/chat',
  // Auth
  userCreate: '/api/user/create',
  userVerify: '/api/user/verify',
  userLogin: '/api/user/login',
  // Subscription
  subscriptionStatus: '/api/subscription/status',
  subscriptionCreate: '/api/subscription/create',
  // Docutron
  fileUpload: '/api/docutron/upload',
  fileProcess: '/api/docutron/process',
  qboImport: '/api/docutron/qbo-import',
  // Version
  version: '/api/version',
} as const;
